import {
  AnyApiFactory,
  configApiRef,
  createApiFactory,
  githubAuthApiRef,
} from '@backstage/core-plugin-api';
import {
  ScmAuth,
  scmAuthApiRef,
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
} from '@backstage/integration-react';

import { techRadarApiRef } from '@backstage/plugin-tech-radar';
import { TechRadarClient } from './lib/TechRadarClient';

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmAuthApiRef,
    deps: { githubAuthApi: githubAuthApiRef },
    factory: ({ githubAuthApi }) => ScmAuth.forGithub(githubAuthApi),
  }),
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  createApiFactory(techRadarApiRef, new TechRadarClient()),
];
